<div class="authincation h-100">
    <div class="container ">
        <div class="row justify-content-center h-100 align-items-center">
            <div class="col-md-6">
                <div class="error-page">
                    <div class="error-inner text-center">
                        <h2 class="error-head">Page not found</h2> 
                        <button type="button"  class="btn btn-secondary" (click)="dashboard()">Dashboard</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>